export const defaultPrimaryColor = '#02123D';
export const defaultPrimaryBtnHoverColor = '#366BF1';
export const defaultPrimaryBtnTextColor = '#FFFFFF';
export const defaultSupportingColorA = '#7B1FA2';
export const defaultSupportingColorB = '#5844D3';
export const defaultSupportingColorC = '#7866EF';
export const defaultSupportingColorD = '#366BF1';
export const defaultSupportingColorE = '#638EFE';
export const defaultSupportingColorF = '#0097A7';
export const defaultSupportingColorG = '#00796B';
export const defaultSupportingColorH = '#497615';
export const defaultSupportingColorI = '#8BC34A';
export const defaultSupportingColorJ = '#FFA723';
export const defaultSupportingColorK = '#DD6E00';
export const defaultBorderRadius = 6;
export const defaultBrandName = 'digitalML';
export const defaultLandingTitle = 'Welcome to digitalML‘s Consumer Portal';
export const defaultLandingMessage = 'Here you‘ll find guides, resources and references to build with digitalML.';
